$(document).ready(function(){
  $(window).on('load', function () {      
    var intervalId = setInterval(function() {
      var fullHtml = $('form [data-testid="klaviyo-countdown"]')[0].outerHTML;
      var $target = $('.kl-teaser-VUAQNR');

      if($(".countdown_min").length == 0){
        if ($target.length && !$target.hasClass('early_bird_access')) {
          $target.addClass('early_bird_access');
        }
      }      
      var $targetSpan = $('.early_bird_access .needsclick span.needsclick');  
      if ($(".countdown_min").length == 0) {
        $targetSpan.append(`<div class='countdown_min'>` + fullHtml + `</div>`);
      }else{
        $('.countdown_min').html(fullHtml);
      }        
    }, 500);    
  });
});



// $(document).ready(function () {
//   $(window).on('load', function () {

//     // Start the first interval to find and inject the container
//     var setupInterval = setInterval(function () {
//       var $target = $('.kl-teaser-VUAQNR');

//       if ($target.length && !$target.hasClass('early_bird_access')) {
//         $target.addClass('early_bird_access');
//       }

//       var $targetSpan = $('.early_bird_access .needsclick span.needsclick');

//       if ($targetSpan.length) {
//         clearInterval(setupInterval); // Stop setup interval
//         var $countdown = $('[data-testid="klaviyo-countdown"]');
//         if ($countdown.length) {
//           var latestHtml = $countdown[0].outerHTML;
//           $targetSpan.html(latestHtml); // Replace old with latest
//         }
//       }
//     }, 300);
//   });
// });
